import { useState } from 'react';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import Card from '../components/ui/Card';
import Modal from '../components/ui/Modal';
import Alert from '../components/ui/Alert';
import LoadingSpinner from '../components/ui/LoadingSpinner';

export default function ComponentDemo() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold bg-gradient-hero bg-clip-text text-transparent mb-2">
            CertifiAble V2
          </h1>
          <p className="text-gray-600">
            Component Library Demo
          </p>
        </div>

        <Card>
          <h2 className="text-2xl font-semibold mb-4">UI Components</h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium mb-3">Buttons</h3>
              <div className="flex flex-wrap gap-2">
                <Button variant="primary">Primary</Button>
                <Button variant="secondary">Secondary</Button>
                <Button variant="outline">Outline</Button>
                <Button variant="ghost">Ghost</Button>
                <Button variant="danger">Danger</Button>
                <Button disabled>Disabled</Button>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-3">Inputs</h3>
              <div className="space-y-4 max-w-md">
                <Input label="Email" type="email" placeholder="you@example.com" />
                <Input label="Password" type="password" placeholder="••••••••" />
                <Input label="Error State" error="This field is required" />
              </div>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-3">Alerts</h3>
              <div className="space-y-3 max-w-2xl">
                <Alert variant="success">Your changes have been saved successfully!</Alert>
                <Alert variant="error">An error occurred. Please try again.</Alert>
                <Alert variant="warning">Your session will expire in 5 minutes.</Alert>
                <Alert variant="info">New features are now available.</Alert>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-3">Loading Spinner</h3>
              <div className="flex gap-4 items-center">
                <LoadingSpinner size="sm" />
                <LoadingSpinner size="md" />
                <LoadingSpinner size="lg" />
              </div>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-3">Modal</h3>
              <Button onClick={() => setIsModalOpen(true)}>Open Modal</Button>
            </div>
          </div>
        </Card>

        <Card>
          <h2 className="text-2xl font-semibold mb-2">Migration Status</h2>
          <ul className="space-y-2 text-gray-700">
            <li>✅ Tailwind CSS configured with V1 brand colors</li>
            <li>✅ Base UI components (Button, Input, Card, Modal, Alert, Spinner)</li>
            <li>✅ Navbar component</li>
            <li>✅ CEUCard component</li>
            <li>✅ Dashboard page</li>
            <li>⏳ Form components (next)</li>
            <li>⏳ Auth integration</li>
          </ul>
        </Card>
      </div>

      <Modal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        title="Example Modal"
      >
        <p className="text-gray-600 mb-4">
          This is a modal built with Headless UI. It's accessible, animated, and fully customizable.
        </p>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>
          <Button onClick={() => setIsModalOpen(false)}>
            Confirm
          </Button>
        </div>
      </Modal>
    </main>
  );
}
